const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1.267 3.393 21.441 17.161",
    width: 21.441,
    height: 17.161,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bnb",
    transform: "matrix(0.306305, 0, 0, 0.306305, -0.264977, -0.278866)",
    style: {}
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 40,
    cy: 34.988,
    rx: 35,
    ry: 23,
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.264,19.258c-8.546,2.066-15.195,6.491-17.441,11.8",
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,34.988V47.835a13,13,0,0,0,4.778,10.08c7.637,6.225,18.353,10.1,30.222,10.1s22.585-3.873,30.222-10.1A13,13,0,0,0,75,47.835V34.988",
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40,
    x2: 40,
    y1: 67.656,
    y2: 57.988,
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.667,
    x2: 51.667,
    y1: 66.72,
    y2: 62.188,
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.333,
    x2: 63.333,
    y1: 61.679,
    y2: 52.988,
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.333,
    x2: 28.333,
    y1: 66.042,
    y2: 57,
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.667,
    x2: 16.667,
    y1: 62.042,
    y2: 52.412,
    style: {
      fill: "none",
      stroke: "var(--theme-secondary)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M49.623,32.5l-8.69-5.708a1.842,1.842,0,0,0-1.866,0L30.377,32.5a1.842,1.842,0,0,1-1.866,0l-1.866-1.226a.679.679,0,0,1,0-1.226L38.134,22.5a3.683,3.683,0,0,1,3.732,0L53.355,30.05a.679.679,0,0,1,0,1.226L51.489,32.5A1.842,1.842,0,0,1,49.623,32.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M40,48a3.449,3.449,0,0,1-1.866-.508L26.645,39.942a.679.679,0,0,1,0-1.226l1.866-1.226a1.842,1.842,0,0,1,1.866,0l8.69,5.708a1.842,1.842,0,0,0,1.866,0l8.69-5.708a1.842,1.842,0,0,1,1.866,0l1.866,1.226a.679.679,0,0,1,0,1.226L41.866,47.488A3.449,3.449,0,0,1,40,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M42.8,34.383l-1.866-1.226a1.842,1.842,0,0,0-1.866,0L37.2,34.383a.679.679,0,0,0,0,1.226l1.866,1.226a1.842,1.842,0,0,0,1.866,0L42.8,35.609A.679.679,0,0,0,42.8,34.383Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M25.645,34.383l-1.866-1.226a1.842,1.842,0,0,0-1.866,0l-1.866,1.226a.679.679,0,0,0,0,1.226l1.866,1.226a1.842,1.842,0,0,0,1.866,0l1.866-1.226A.679.679,0,0,0,25.645,34.383Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M59.953,34.383l-1.866-1.226a1.842,1.842,0,0,0-1.866,0l-1.866,1.226a.679.679,0,0,0,0,1.226l1.866,1.226a1.842,1.842,0,0,0,1.866,0l1.866-1.226A.679.679,0,0,0,59.953,34.383Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8ed942bbed1b4d94f498834783d2e9ca.svg";
export { ForwardRef as ReactComponent };